export default defineNuxtRouteMiddleware((to, from) => {
  if (from.path.includes("/market") && !to.path.includes("/market")) {
    const userCache = useUserCache();
    userCache.clearUserProfiles();
  }
});
